<template>
  <div class="driver-details-tab" style="height: 90%">
    <viewEditToggle @save="save" ref="driverDetails">
      <template v-slot:header> </template>
      <template slot-scope="{ viewEdit }">
        <b-row class="mb-30">
          <b-col cols="12">
            <b-tabs no-nav-style active-nav-item-class="activeTab">
              <b-tab title="Personal">
                <b-row class="p-10">
                  <b-col cols="5" align="center">
                    <b-avatar
                      :id="`onlineStatus`"
                      badge
                      :badge-variant="
                        driver.isOnDuty === true ? 'success' : 'secondary'
                      "
                      size="130px"
                      badge-top
                      badge-offset="0em"
                      :src="address.profilePictureUrl"
                      v-b-tooltip.hover
                      :title="driver.isOnDuty === true ? 'Online' : 'Offline'"
                      style="
                         {
                          padding-top: 5px;
                        }
                      "
                    >
                    </b-avatar>
                    <fileUploadTemplate
                      template="image"
                      fileKey="profilePictureUrl"
                      :crop="true"
                      :selectCallback="selectCallback"
                      :pillStyleUploadButton="true"
                      class="mt-10"
                      :disabled="!viewEdit"
                    />
                  </b-col>
                  <b-col cols="6" class="mt-5">
                    <div class="mb-10">
                      <star-rating
                        id="ratings"
                        :star-size="20"
                        :inline="true"
                        :round-start-rating="false"
                        :read-only="true"
                        :border-width="2"
                        :max-rating="5.0"
                        :rating="
                          typeof driver.stats !== `undefined`
                            ? parseFloat(driver.stats.avgRating.toFixed(1))
                            : 0
                        "
                      />
                    </div>
                    <b-form-group
                      label="Referral Code :"
                      label-size="sm"
                      label-cols-md="6"
                      class="m-0"
                    >
                      <h6>{{ driver.referralCode }}</h6>
                    </b-form-group>
                    <b-form-group
                      label="Invited by Referral code :"
                      label-size="sm"
                      label-cols-md="6"
                      class="m-0"
                    >
                      <b-form-input
                        id="inputPromoCode"
                        v-model="driver.invitedBy.referralCode"
                        :disabled="!viewEdit"
                        size="sm"
                        trim
                        required
                        :state="
                          typeof driverErrors.promotionCode !== 'undefined'
                            ? false
                            : null
                        "
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      label="Status:"
                      label-size="sm"
                      label-cols-md="3"
                      class="m-0"
                    >
                      <b-form-select
                        id="DriverStatus"
                        size="sm"
                        v-model="driver.status"
                        :options="driver_status"
                        :disabled="!viewEdit"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                  <hr style="width: 90%" />
                  <b-col cols="6">
                    <b-form-group
                      class="m-0"
                      label="First Name:"
                      label-for="inputFirstName"
                      :invalid-feedback="driverErrors.firstName"
                      :state="
                        typeof driverErrors.firstName !== 'undefined'
                          ? false
                          : null
                      "
                      label-cols-md="3"
                      label-size="sm"
                    >
                      <b-form-input
                        id="inputFirstName"
                        v-model="driver.firstName"
                        size="sm"
                        :disabled="!viewEdit"
                        trim
                        required
                        :state="
                          typeof driverErrors.firstName !== 'undefined'
                            ? false
                            : null
                        "
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col cols="6">
                    <b-form-group
                      class="m-0"
                      label="Last Name:"
                      label-for="inputLastName"
                      :invalid-feedback="driverErrors.lastName"
                      :state="
                        typeof driverErrors.lastName !== 'undefined'
                          ? false
                          : null
                      "
                      label-cols-md="3"
                      label-size="sm"
                    >
                      <b-form-input
                        id="inputLastName"
                        v-model="driver.lastName"
                        :disabled="!viewEdit"
                        size="sm"
                        trim
                        required
                        :state="
                          typeof driverErrors.lastName !== 'undefined'
                            ? false
                            : null
                        "
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      label="Date of Birth:"
                      label-for="date_input"
                      label-cols-lg="3"
                      label-size="sm"
                      class="m-0"
                    >
                    <b-form-input
                        v-model="driver.dateOfBirth"
                        trim
                        placeholder="DD-MM-YYYY"
                        v-mask="'##-##-####'"
                        :state="(typeof driverErrors.dateOfBirth === 'undefined') ? null : false"
                        :disabled="!viewEdit"
                   ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" class="mb-0" align="center">
                    <b-form-group
                      label="Account creation date (Melbourne, Australia):"
                      label-size="sm"
                      label-cols-md="7"
                      class="mb-0;ml-2"
                    >
                      <h6>{{ driver.createdTs }}</h6>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Contact">
                <b-row class="p-15">
                  <b-col cols="12" md="6">
                    <b-form-group
                      label="Phone:"
                      :invalid-feedback="driverErrors.phone"
                      :state="
                        typeof driverErrors.phone !== 'undefined' ? false : true
                      "
                      label-size="sm"
                    >
                      <b-form-input
                        v-model="driver.phone"
                        type="text"
                        size="sm"
                        trim
                        placeholder="Mobile Number"
                        :state="
                          typeof driverErrors.phone !== 'undefined'
                            ? false
                            : null
                        "
                        :disabled="!viewEdit"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group
                      label="Email:"
                      :invalid-feedback="driverErrors.email"
                      :state="
                        typeof driverErrors.email !== 'undefined' ? false : true
                      "
                      label-size="sm"
                    >
                      <b-form-input
                        v-model="driver.email"
                        type="email"
                        trim
                        placeholder="Email"
                        :state="
                          typeof driverErrors.email !== 'undefined'
                            ? false
                            : null
                        "
                        :disabled="!viewEdit"
                        size="sm"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      label="Address:"
                      :invalid-feedback="driverErrors.address"
                      :state="
                        typeof driverErrors.address !== 'undefined'
                          ? false
                          : true
                      "
                      label-size="sm"
                    >
                      <b-form-input
                        v-model="driver.profile.address"
                        type="text"
                        trim
                        placeholder="Address"
                        :state="
                          typeof driverErrors.address !== 'undefined'
                            ? false
                            : null
                        "
                        :disabled="!viewEdit"
                        size="sm"
                        v-if="!viewEdit"
                      ></b-form-input>
                      <googleSearchAddress
                        v-else
                        @addressCallback="addressCallback"
                        :placeholder="address.address"
                        :state="null"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group
                      label="Suburb:"
                      :invalid-feedback="driverErrors.city"
                      :state="
                        typeof driverErrors.city !== 'undefined' ? false : true
                      "
                      label-size="sm"
                    >
                      <b-form-input
                        v-model="address.city"
                        type="text"
                        trim
                        placeholder="Suburb"
                        :state="
                          typeof driverErrors.city !== 'undefined'
                            ? false
                            : null
                        "
                        :disabled="true"
                        size="sm"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group
                      label="State:"
                      :invalid-feedback="driverErrors.state"
                      :state="
                        typeof driverErrors.state !== 'undefined' ? false : true
                      "
                      label-size="sm"
                    >
                      <b-form-input
                        v-model="address.state"
                        type="text"
                        trim
                        placeholder="State"
                        :state="
                          typeof driverErrors.state !== 'undefined'
                            ? false
                            : null
                        "
                        :disabled="true"
                        size="sm"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group
                      label="Postcode:"
                      :invalid-feedback="driverErrors.postalCode"
                      :state="
                        typeof driverErrors.postalCode !== 'undefined'
                          ? false
                          : true
                      "
                      label-size="sm"
                    >
                      <b-form-input
                        v-model="address.postalCode"
                        type="number"
                        trim
                        placeholder="Postcode"
                        :state="
                          typeof driverErrors.postalCode !== 'undefined'
                            ? false
                            : null
                        "
                        :disabled="true"
                        size="sm"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Advance Booking">
                <b-row class="p-10">
                  <b-col cols="12">
                    <b-form-group
                      label="Accepts advance bookings:"
                      label-cols="5"
                      label-size="sm"
                      class="m-0"
                    >
                      <b-form-checkbox
                        v-model="driver.acceptsAdvancedBooking"
                        ref="acceptAdvanceBooking"
                        switch
                        :disabled="isABFreezeChange"
                        size="lg"
                        class="my-5"
                        v-b-tooltip.hover.right
                        :title="
                          driver.acceptsAdvancedBooking === true ? 'Yes' : 'No'
                        "
                      ></b-form-checkbox>
                    </b-form-group>
                    <b-form-group
                      label="Accepts advance bookings when offline:"
                      label-cols="6"
                      class="m-0"
                      label-size="sm"
                    >
                      <b-form-checkbox
                        v-model="driver.acceptsAdvancedBookingOffline"
                        ref="acceptAdvanceBookingOffline"
                        switch
                        :disabled="isABFreezeChange"
                        size="lg"
                        class="my-5"
                        v-b-tooltip.hover.right
                        :title="
                          driver.acceptsAdvancedBookingOffline === true
                            ? 'Yes'
                            : 'No'
                        "
                      ></b-form-checkbox>
                    </b-form-group>

                    <b-form-group label-cols="5" class="m-0" label-size="sm">
                      <template slot="label"
                        >Freeze advance bookings
                        <a
                          href="#"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Be careful! Freeze ABs will disable the management of its options by the driver."
                          >[!] </a
                        >:
                      </template>
                      <b-form-checkbox
                        v-model="driver.isAdvancedBookingFreeze"
                        switch
                        :disabled="!viewEdit"
                        size="lg"
                        class="my-5"
                        v-b-tooltip.hover.right
                        :title="
                          driver.isAdvancedBookingFreeze === true ? 'Yes' : 'No'
                        "
                        @change="freezeAdvanceBooking"
                      ></b-form-checkbox>
                    </b-form-group>

                    <b-form-group label-cols="3" class="m-0" label-size="sm">
                      <template slot="label"
                        >Freeze facilities
                        <a
                          href="#"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Be careful! Freeze facilities will disable the management of its options by the driver."
                          >[!] </a
                        >:
                      </template>
                      <b-form-checkbox
                        v-model="driver.isFacilitiesFreeze"
                        switch
                        :disabled="!viewEdit"
                        size="lg"
                        class="my-5"
                        v-b-tooltip.hover.right
                        :title="
                          driver.isFacilitiesFreeze === true ? 'Yes' : 'No'
                        "
                      ></b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Business" class="mb-10">
                <b-row class="p-10">
                  <b-col cols="10">
                    <b-form-group
                      label="Stripe :"
                      label-cols-md="4"
                      class="m-0"
                      label-size="sm"
                    >
                      <div v-if="(typeof driver.stripe === 'undefined') ? false : true" class="text-success" style="margin: 6px 0 0 0;">Connected</div>
                      <div v-else class="text-danger" style="margin: 6px 0 0 0;">Not connected</div>
                    </b-form-group>
                    <b-form-group
                      label="Shareholder :"
                      label-cols-md="4"
                      class="m-0"
                      label-size="sm"
                    >
                      <b-form-checkbox
                        v-model="driver.shareholder"
                        switch
                        :disabled="!viewEdit"
                        size="lg"
                        class="my-5"
                        v-b-tooltip.hover.left
                        :title="driver.shareholder === true ? 'Yes' : 'No'"
                      ></b-form-checkbox>
                    </b-form-group>

                    <div v-if="abn_details === null">
                      <b-form-group
                        id="abn-group"
                        label-for="abn"
                        :invalid-feedback="abnErrorMsg"
                        :state="abnValid"
                        label-size="sm"
                      >
                      <template slot="label"
                        >ABN
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://abr.business.gov.au"
                          id="abn-link"
                          >[check it] </a
                        >:
                      </template>
                        <b-form-input
                          id="abn"
                          size="sm"
                          v-model="form.abn"
                          type="text"
                          required
                          placeholder="## ### ### ###"
                          v-mask="'## ### ### ###'"
                          :state="abnValid"
                          @input="abnValid = null"
                          :disabled="!viewEdit"
                        >
                        </b-form-input>
                      </b-form-group>
                      <b-button
                        type="submit"
                        variant="outline-primary"
                        pill
                        size="sm"
                        @click="abnLookup"
                        :disabled="!viewEdit"
                        >Lookup</b-button
                      >
                    </div>
                    <div v-else>
                      <b-form-group
                        id="abn-group"
                        label-for="abn"
                        label-size="sm"
                        label-cols-md="4"
                        class="m-0"
                      >
                      <template slot="label"
                        >ABN
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          :href="'https://abr.business.gov.au/ABN/View?id='+abn_details.abn"
                          id="abn-link"
                          >[check it] </a
                        >:
                      </template>
                        <p>{{ abn_details.abn }}</p>
                      </b-form-group>
                      <b-form-group
                        id="business-name-group"
                        label="Business Name :"
                        label-for="business-name"
                        label-size="sm"
                        label-cols-md="4"
                        class="m-0"
                      >
                        <p>{{ abn_details.business_name }}</p>
                      </b-form-group>

                      <h5 v-if="abn_details.gst" class="text-success">
                        <font-awesome-icon icon="clipboard-check" /> Registered
                        for GST
                      </h5>
                      <h5 v-else class="text-danger">Not registered for GST</h5>
                      <div v-if="editAbn">
                        <b-button
                          class="btn-edit"
                          type="button"
                          size="sm"
                          variant="link"
                          @click.prevent="updateAbnButton"
                          :disabled="!viewEdit"
                          >Edit ABN</b-button
                        >
                      </div>
                      <div v-if="saveAbn">
                        <b-button
                          type="button"
                          size="sm"
                          variant="outline-primary"
                          pill
                          @click.prevent="saveAbnButton"
                          >Save ABN</b-button
                        >
                        <b-button
                          type="button"
                          size="sm"
                          variant="link"
                          @click="closeAbn"
                          >Close</b-button
                        >
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-col>

          <b-col cols="12" class="ml-15">
            <b-button variant="primary" @click="save" v-if="viewEdit"
              >Save</b-button
            >
          </b-col>
        </b-row>
      </template>
    </viewEditToggle>
  </div>
</template>

<script>
import moment from "moment";
import shebahApi from "@/services/shebah/index";
import viewEditToggle from "@/components/viewEditToggle";
import general from "@/utilities/general/index";
import StarRating from "vue-star-rating";
import fileUploadTemplate from "@/components/file-upload-template.vue";
import { googleSearchAddress } from "@/components/google/index";

export default {
  name: "driverDetails",
  components: {
    viewEditToggle,
    StarRating,
    fileUploadTemplate,
    googleSearchAddress,
  },
  computed: {
    authUser() {
      return this.$store.getters["authUser/user"];
    },
    scrollBar() {
      return this.$store.getters["general/scrollbar"];
    },
  },
  props: {
    driver: Object,
  },
  watch: {
    viewEdit(val) {
      if (!val) {
        this.isABFreezeChange = false;
      }
    },
  },
  data() {
    return {
      address: null,
      abn_details: null,
      abnErrorMsg: "",
      abnValid: null,
      form: {},
      editAbn: false,
      saveAbn: false,
      driverErrors: {},
      isABFreezeChange: true,
      driver_status: [
        { text: "Incomplete", value: "incomplete" },
        { text: "Pending Approval", value: "pending" },
        { text: "Active", value: "active" },
        { text: "Suspended", value: "suspended" },
        { text: "Onboarded", value: "onboarded" },
        { text: "Deleted", value: "deleted" },
        { text: "Document Expire", value: "document_expire" },
        { text: "Removed By HQ", value: "removedByHQ"}
      ],
    };
  },
  created() {
    this.address = this.driver.profile;
    if (typeof this.driver.abn !== "undefined" && this.driver.abn !== "") {
      this.editAbn = true;
      this.saveAbn = false;
      this.abn_details = {
        business_name: this.driver.business_name,
        abn: this.driver.abn,
        gst: (() => {
          if (
            typeof this.driver.gstRegistered !== "undefined" &&
            this.driver.gstRegistered
          ) {
            return 1;
          }
        })(),
      };
    }
  },
  methods: {
    async save() {
      let validate = general.validation();

      let validationRules = {};
      validationRules = {
        firstName: {
          rules: "required",
          field_name: "First name",
        },
        lastName: {
          rules: "required",
          field_name: "Last name",
        },
        email: {
          rules: "required|email",
          field_name: "Email",
        },
        phone: {
          rules: "required",
          field_name: "Phone",
        },
        invitedReferralCode: {
          rules: "",
          field_name: "",
        },
        promotionCode: {
          rules: "",
          field_name: "",
        },
      };
      if (this.address.state === "") {
        validate.setError("state", "state is required field.");
      }
      if (this.address.postalCode === "") {
        validate.setError("postalCode", "postCode is required field.");
      }
      if(!this.isValidate(this.driver.dateOfBirth)){
        validate.setError("dateOfBirth","Please enter a valid date.")
      }
      validate.setValidFields(validationRules);
      if (validate.isValid(this.driver)) {
        this.driverErrors = {};
        let updatedDriver = {
          email: this.driver.email,
          phone: this.driver.phone,
          firstName: this.driver.firstName,
          lastName: this.driver.lastName,
          dateOfBirth: this.driver.dateOfBirth,
          profile: this.driver.profile,
          acceptsAdvancedBooking: this.driver.acceptsAdvancedBooking,
          acceptsAdvancedBookingOffline: this.driver
            .acceptsAdvancedBookingOffline,
          isAdvancedBookingFreeze: this.driver.isAdvancedBookingFreeze,
          isFacilitiesFreeze: this.driver.isFacilitiesFreeze,
          business_name:
            this.abn_details != null ? this.abn_details.business_name : "",
          gstRegistered:
            this.abn_details != null ? this.abn_details.gst : false,
          abn: this.abn_details != null ? this.abn_details.abn : "",
          shareholder: this.driver.shareholder,
          invitedReferralCode: this.driver.invitedBy.referralCode,
          status: this.driver.status,
        };
        updatedDriver.profile.address = this.address.address;
        updatedDriver.profile.state = this.address.state;
        updatedDriver.profile.city = this.address.city;
        updatedDriver.profile.postalCode = this.address.postalCode;
        updatedDriver.profile.profilePictureUrl = this.address.profilePictureUrl;

        try {
          let services = await shebahApi.api.drivers.updateDetails(
            this.driver._id,
            updatedDriver
          );
          this.$refs.driverDetails.changeState("view");
          this.$emit("updated", services);
        } catch (e) {
          if (typeof e.response !== "undefined") {
            if (
              typeof e.response.data.error !== "undefined" &&
              typeof e.response.data.error.collection !== "undefined"
            ) {
               this.driverErrors=e.response.data.error.collection;
            }
          } else {
            console.log(e);
            //this.abnErrorMsg = e;
          }
        }
      } else {
        this.driverErrors = validate.errors;
        //e.preventDefault();
      }
    },
    resetView() {
      this.$refs.driverDetails.changeState("view");
    },
    async selectCallback(key, file, crop) {
      await shebahApi.api.drivers.uploadProfileImage(
        this.driver._id,
        {
          pictureUploadId: file[0],
          height: crop.height,
          width: crop.width,
          x: crop.x,
          y: crop.y,
        },
        {
          _id: this.driver._id,
          profile: this.driver.profile,
          firstName: this.driver.firstName,
          lastName: this.driver.lastName,
          email: this.driver.email,
          status: this.driver.status,
        }
      );
      let uploadedImage = await shebahApi.api.drivers.view(this.driver._id);
      this.address.profilePictureUrl = uploadedImage.profile.profilePictureUrl;
      this.$emit("updated", uploadedImage);
      // this.$store.dispatch('authUser/getAlerts');
    },
    freezeAdvanceBooking(checked) {
      if (checked) {
        this.driver.acceptsAdvancedBooking = false;
        this.driver.acceptsAdvancedBookingOffline = false;
        this.isABFreezeChange = true;
      } else {
        this.isABFreezeChange = false;
      }
    },
    async abnLookup() {
      try {
        if (this.form.abn === "") {
          throw "ABN missing.";
        }
        let authData = await shebahApi.api.drivers.validateBusiness(
          this.form.abn
        );

        this.saveAbn = true;
        this.editAbn = false;

        this.abn_details = {};

        this.abn_details.abn = this.form.abn;
        this.abn_details.status = authData.entityStatus.entityStatusCodev;

        if (typeof authData.mainName !== "undefined") {
          this.abn_details.business_name = authData.mainName.organisationName;
          this.abn_details.effective_from = authData.mainName.effectiveFrom;
        } else if (typeof authData.legalName !== "undefined") {
          this.abn_details.business_name = `${authData.legalName.givenName} ${authData.legalName.familyName}`;
          this.abn_details.effective_from = authData.legalName.effectiveFrom;
        }

        if (typeof authData.goodsAndServicesTax !== "undefined") {
          this.abn_details.gst = true;
        } else {
          this.abn_details.gst = false;
        }
      } catch (e) {
        this.abnValid = false;
        if (typeof e.response !== "undefined") {
          this.abnErrorMsg = e.response.data.error.msg;
        } else {
          this.abnErrorMsg = e;
        }
      }
    },
    updateAbnButton() {
      this.abn_details = null;
    },
    async saveAbnButton() {
      this.saveAbn = false;
      this.editAbn = true;
    },
    closeAbn() {
      this.saveAbn = false;
      this.editAbn = true;
    },
    addressCallback(address) {
      Object.assign(this.address, address);
    },
    isValidate: function(dateStr) {
    let s = dateStr.split('-');
    let d = new Date(+s[2], s[1]-1, +s[0]);
    if (Object.prototype.toString.call(d) === "[object Date]") {
        if (!isNaN(d.getTime()) && d.getDate() == s[0] && 
            d.getMonth() == (s[1] - 1)) {
            return true;
        }
    }
    return false;
}
  }
};
</script>

<style lang="scss">
#onlineStatus.b-avatar .b-avatar-badge {
  min-height: 0.7em;
  min-width: 0.7em;
  border: 1px solid white;
}
.activeTab {
  animation: mymove 3s infinite;
}
@keyframes mymove {
  50% {
    font-weight: bold;
    color: blue;
  }
}
.ABLabel {
  font-weight: normal !important;
}
</style>
